import React from "react";

import LandingComponent from "./Landing";

function Landing() {
  return <LandingComponent />;
}
export default Landing;
